import { createStyles, makeStyles } from "@material-ui/core";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import { ColumnModel, PageInfoModel } from "../../models/common.model";
import { GetRegisteredSalesToApproveResponse } from "../../models/settlement.model";
import TabsEmptyStyle from "../../pages/permission/components/TabsEmptyStyle";
import { useQueryClient } from "react-query";
import { SETTLEMENT_REQUEST_KEY } from "../../config/cacheKey";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};

const SelectTable = ({
  listData,
  columns,
  addToList,
  addAllToList,
  removeAllFromList,
  removeFromList,
  paginationInfo,
  setCurrentPaginationInfo,
  currentPaginationInfo,
  handleRowClick,
}: {
  listData: GetRegisteredSalesToApproveResponse[];
  columns: ColumnModel[];
  addToList?: Function;
  removeFromList?: Function;
  addAllToList?: Function;
  removeAllFromList?: Function;
  paginationInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handleRowClick: Function;
}) => {
  const [allData, setAllData] = React.useState<
    GetRegisteredSalesToApproveResponse[]
  >(listData);

  const classes = useStyles();
  const queryClient = useQueryClient();
  const [selectedRow, setSelectedRow] = useState(undefined);

  let selectedDataCache = queryClient.getQueryData<
    GetRegisteredSalesToApproveResponse[]
  >(SETTLEMENT_REQUEST_KEY);

  const addAllData = () => {
    setAllData([]);
    queryClient.setQueryData<GetRegisteredSalesToApproveResponse[]>(
      SETTLEMENT_REQUEST_KEY,
      [...(selectedDataCache || []), ...listData]
    );
    addAllToList !== undefined && addAllToList();
  };
  const addToSelectedList = (
    e: React.MouseEvent<HTMLTableCellElement>,
    row: GetRegisteredSalesToApproveResponse
  ) => {
    e.stopPropagation();
    queryClient.setQueryData<GetRegisteredSalesToApproveResponse[]>(
      SETTLEMENT_REQUEST_KEY,
      [...(selectedDataCache || []), row]
    );
    setAllData(allData.filter((item) => item.saleKey !== row.saleKey));
    addToList !== undefined && addToList(row);
  };
  const removeFromSelectedList = (
    e: React.MouseEvent<HTMLTableCellElement>,
    row: GetRegisteredSalesToApproveResponse
  ) => {
    setAllData([...allData, row]);
    queryClient.setQueryData<GetRegisteredSalesToApproveResponse[]>(
      SETTLEMENT_REQUEST_KEY,
      selectedDataCache!.filter((item) => item.saleKey !== row.saleKey)
    );
    removeFromList !== undefined && removeFromList(row);
  };
  const removeAllData = () => {
    setAllData(listData);
    removeAllFromList !== undefined && removeAllFromList();
  };

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleChangePagination = (event: any, value: any) => {
    setSelectedRow(undefined);
    changePageNumber(value);
  };

  useEffect(() => {
    setAllData(listData);
  }, [listData]);
  return (
    <div style={{ height: "100%" }}>
      {/* top table */}
      <div
        className="cardTableBorder"
        style={{
          marginBottom: "40px",
          width: "100%",
          height: "50%",
        }}
      >
        {allData.length > 0 ? (
          <TableContainer
            style={{
              background: "#fff",
              height: "100%",
            }}
            //   className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft cursorPointer`}
                >
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight "
                    align="right"
                    style={{
                      width: "10vh",
                      minWidth: "10vh",
                      position: "sticky",
                      right: 0,
                      zIndex: 100,
                    }}
                  >
                    <Tooltip arrow title="انتخاب همه">
                      <Button
                        className=" colorTitle textFont12 fontWeight "
                        onClick={() => {
                          addAllData();
                        }}
                        style={{
                          textAlign: "center",
                          fontWeight: "bolder",
                        }}
                      >
                        <PlaylistAddIcon
                          style={{ background: "transparent" }}
                        />
                      </Button>
                    </Tooltip>
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {allData
                  ? allData.map(
                      (
                        row: GetRegisteredSalesToApproveResponse,
                        rowIndex: any
                      ) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            selected={selectedRow === rowIndex}
                            onClick={() => {
                              setSelectedRow(rowIndex);
                              handleRowClick(row.saleKey);
                            }}
                          >
                            <TableCell
                              className={`colorTitle textFont12 fontWeight ${
                                rowIndex % 2 === 0 ? "stickyColO" : "stickyColE"
                              }`}
                              align="right"
                              style={{
                                width: "10vh",
                                minWidth: "10vh",
                                textAlign: "center",
                                fontWeight: "bolder",
                                position: "sticky",
                                right: 0,
                                zIndex: 2,
                                backgroundColor:
                                  selectedRow === rowIndex
                                    ? "#cee5d3"
                                    : rowIndex % 2 === 0
                                    ? "#fff"
                                    : "#e9e9e9",
                              }}
                              onClick={(e) => {
                                addToSelectedList(e, row);
                              }}
                            >
                              <Button
                                className=" colorTitle textFont12 fontWeight "
                                style={{
                                  textAlign: "center",
                                  fontWeight: "bolder",
                                }}
                              >
                                <PlaylistAddIcon
                                  style={{ background: "transparent" }}
                                />
                              </Button>
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[
                                  column.id as keyof GetRegisteredSalesToApproveResponse
                                ];
                              return (
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                  sx={{
                                    color:
                                      column.id ===
                                      "settlementDeadlineDate_Persian"
                                        ? "#FB8C00"
                                        : "",
                                  }}
                                >
                                  {column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      }
                    )
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TabsEmptyStyle
            height="100%"
            completeText="تمامی موارد این صفحه انتخاب شده است."
          />
        )}
        <div style={{ marginTop: "15px" }}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={12}
              sm={4}
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>
                  {paginationInfo?.total - (selectedDataCache?.length ?? 0)}
                </span>{" "}
                مورد
              </span>
            </Grid>
            <Grid item xs={12} sm={4} display="flex" justifyContent="center">
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                // color="primary"
                sx={{
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                }}
                count={
                  paginationInfo
                    ? Math.ceil(paginationInfo.total / paginationInfo.pageSize)
                    : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </div>
      </div>
      <div style={{ marginTop: "80px" }}>
        <span
          style={{
            color: "#1D4A87",
            fontSize: "16px",
            fontWeight: "bold",
            marginRight: "15px",
            width: "100%",
          }}
        >
          <span
            style={{ color: "#1D4A87", fontSize: "16px", fontWeight: "bold" }}
          >
            لیست منتخب تسویه &nbsp;
            <span
              style={{
                color: "#1D4A87",
                fontSize: "14px",
                fontWeight: "normal",
              }}
            >
              (
              {selectedDataCache?.length !== undefined &&
              selectedDataCache?.length != null
                ? selectedDataCache?.length
                : 0}{" "}
              مورد){" "}
            </span>
          </span>
        </span>
      </div>
      {/* bottom table */}
      <Box
        className="cardTableBorder"
        style={{
          marginTop: "10px",
          width: "100%",
        }}
        height={{ xs: "32%", md: "35%" }}
      >
        {selectedDataCache && selectedDataCache?.length > 0 ? (
          <TableContainer
            style={{
              background: "#fff",
              height: "100%",
            }}
            // className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft cursorPointer`}
                >
                  <TableCell
                    align="right"
                    style={{
                      width: "10vh",
                      minWidth: "10vh",
                      zIndex: "100",
                    }}
                    sx={{ backgroundColor: "#edefef" }}
                  >
                    <Tooltip arrow title="لغو همه">
                      <Button
                        className=" colorTitle textFont12 fontWeight"
                        onClick={() => {
                          removeAllData();
                        }}
                        style={{
                          textAlign: "center",
                          fontWeight: "bolder",
                        }}
                      >
                        <img
                          className="cursorPointer"
                          style={{
                            width: "17px",
                            height: "17px",
                            marginBottom: ".5vh",
                          }}
                          src="images/RemoveFromPlaylist.svg"
                          alt=""
                        />
                      </Button>
                    </Tooltip>
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {selectedDataCache &&
                  selectedDataCache?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <TableCell
                          className={`colorTitle textFont12 fontWeight ${
                            rowIndex % 2 === 0 ? "stickyColO" : "stickyColE"
                          }`}
                          align="right"
                          style={{
                            width: "10vh",
                            minWidth: "10vh",
                            textAlign: "center",
                            fontWeight: "bolder",
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                            backgroundColor:
                              rowIndex % 2 === 0 ? "#fff" : "#e9e9e9",
                            overflow: "hidden",
                          }}
                          onClick={(e) => {
                            removeFromSelectedList(e, row);
                          }}
                        >
                          <Button
                            className=" colorTitle textFont12 fontWeight "
                            style={{
                              textAlign: "center",
                              fontWeight: "bolder",
                            }}
                          >
                            <img
                              className="cursorPointer"
                              style={{
                                width: "17px",
                                height: "17px",
                                marginBottom: ".5vh",
                                background: "transparent",
                              }}
                              src="images/RemoveFromPlaylist.svg"
                              alt=""
                            />
                          </Button>
                        </TableCell>

                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetRegisteredSalesToApproveResponse
                            ];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TabsEmptyStyle
            height="100%"
            completeText="موردی به لیست تسویه اضافه نشد"
          />
        )}
      </Box>
    </div>
  );
};

export default SelectTable;
